import { useQuery } from '@tanstack/react-query';
export const stubOrderData = [
    {
        _id: '1',
        order_id: 'ORD-2024-001',
        origin: 'Los Angeles, CA',
        destination: 'Phoenix, AZ',
        margin: 700.0,
        vessel: 'MSC GULSUN',
        accounting_review_date: '2024-01-15T11:30:00Z',
        automated_billing_evaluated_paused_timestamp: '2024-01-10T14:30:00Z',
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 1800.0,
        bco: 'ACME Corp',
        billing_status_billing_status: 'invoiced',
        billing_status_billing_status_updated_at: '2024-01-14T09:00:00Z',
        billing_status_invoice_grouping: 'Weekly',
        billing_status_override_billing_status_note: null,
        billing_status_override_billing_status_reason_codes: null,
        billing_status_pending_accessorial_evaluation: 'Complete',
        billing_status_override_billing_status: null,
        cargo_description: 'Electronics - Consumer Goods',
        carrier_accessorial_total: 150.0,
        carrier_cost_total: 1800.0,
        carrier_fsc_total: 180.0,
        carrier_linehaul: 1400.0,
        carrier_other_accessorial_total: 70.0,
        carrier_total: 1800.0,
        container_number: 'MSKU1234567',
        created_at: '2024-01-05T08:00:00Z',
        created_by: 'john.smith@cargomatic.com',
        date_created: '2024-01-05T11:30:00Z',
        destination_city: 'Phoenix',
        destination_name: 'Phoenix Distribution Center',
        destination_state: 'AZ',
        discussion: 'Priority shipment - handle with care',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: '2024-02-15T11:30:00Z',
        market: 'Southwest',
        missing_docs_report: 'None',
        mode: 'Truck',
        move_type: 'Import',
        order_carrier: 'Swift Transport',
        order_received_date: '2024-01-04T11:30:00Z',
        order_status: 'complete',
        order_timezone: 'America/Los_Angeles',
        order_type: 'Standard',
        order_updated: '2024-01-15T16:00:00Z',
        origin_city: 'Los Angeles',
        origin_name: 'Port of Los Angeles',
        origin_state: 'CA',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: 'None',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, BOL',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'None',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#, SO#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'None',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'None',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'None',
        pending_carrier_accessorials: 'None',
        pending_shipper_accessorials: 'None',
        railroads: 'BNSF',
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'DM32089',
                optimized: 'DM32089',
                _id: '5bbd231b4c202300122eeffc',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DN24809',
                optimized: 'DN24809',
                _id: '5bbd231b4c202300122eeffb',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Door-to-Door',
        shipment_id: 'SHP-2024-001-A',
        shipper: 'ACME Corporation',
        shipper_accessorial_total: 200.0,
        shipper_account_support_agent: 'Sarah Johnson',
        shipper_account_support_agent_tier2: 'Mike Wilson',
        shipper_billing_rep: 'Emily Davis',
        shipper_chassis_total: 50.0,
        shipper_cost_total: 2500.0,
        shipper_customer_success_manager: 'David Brown',
        shipper_data_entry_agent: 'Lisa Chen',
        shipper_demurrage_total: 0.0,
        shipper_fsc_total: 250.0,
        shipper_linehaul: 1900.0,
        shipper_ops_group: 'West Coast Ops',
        shipper_ops_manager: 'Robert Taylor',
        shipper_other_accessorial_total: 100.0,
        shipper_sales_rep: 'Jennifer Martinez',
        shipper_storage_total: 0.0,
        shipper_total: 2500.0,
        shorthaul_ops_customer_success: 'Amy White',
        shorthaul_ops_operations_manager: 'Chris Green',
        standard_reference_numbers_booking_number: 'BK-2024-001',
        standard_reference_numbers_category: 'Import',
        standard_reference_numbers_delivery_order: 'DO-2024-001',
        standard_reference_numbers_final_destination: 'Phoenix, AZ',
        standard_reference_numbers_master_bol: 'MBOL-12345',
        standard_reference_numbers_mo_number: 'MO-2024-001',
        standard_reference_numbers_mode: 'Truck',
        standard_reference_numbers_po_number: 'PO-12345',
        standard_reference_numbers_work_order_number: 'WO-2024-001',
        steamship: 'MSC',
        team_commercial_account_manager: 'Tom Anderson',
        team_commercial_sales_rep: 'Nancy Lee',
        team_drayage_ops_customer_success: 'Kevin Park',
        team_drayage_ops_data_entry: 'Maria Garcia',
        total: 2500.0,
        total_invoiced: 2500.0,
        train: 'BNSF-Q-LA-PHX',
        unbilled_approved: 0.0,
        unbilled_charges: 0.0,
        unbilled_pending: 0.0,
        vendor_total: 1800.0,
        weight: 42000,
    },
    {
        _id: '2',
        order_id: 'ORD-2024-002',
        origin: 'Dallas, TX',
        destination: 'Atlanta, GA',
        margin: 800.0,
        vessel: 'COSCO SHIPPING UNIVERSE',
        accounting_review_date: '2024-01-18T11:30:00Z',
        automated_billing_evaluated_paused_timestamp: null,
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 2200.0,
        bco: 'Global Logistics',
        billing_status_billing_status: 'ready_to_bill',
        billing_status_billing_status_updated_at: '2024-01-17T11:30:00Z',
        billing_status_invoice_grouping: 'Daily',
        billing_status_override_billing_status_note: null,
        billing_status_override_billing_status_reason_codes: null,
        billing_status_pending_accessorial_evaluation: 'Pending',
        billing_status_override_billing_status: null,
        cargo_description: 'Auto Parts - OEM',
        carrier_accessorial_total: 200.0,
        carrier_cost_total: 2400.0,
        carrier_fsc_total: 240.0,
        carrier_linehaul: 1800.0,
        carrier_other_accessorial_total: 160.0,
        carrier_total: 2400.0,
        container_number: 'COSCO9876543',
        created_at: '2024-01-08T10:00:00Z',
        created_by: 'jane.doe@cargomatic.com',
        date_created: '2024-01-08T11:30:00Z',
        destination_city: 'Atlanta',
        destination_name: 'Atlanta Logistics Hub',
        destination_state: 'GA',
        discussion: 'Customer requested expedited delivery',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: '2024-02-18T11:30:00Z',
        market: 'Southeast',
        missing_docs_report: 'POD Missing',
        mode: 'Intermodal',
        move_type: 'Import',
        order_carrier: 'XPO Logistics',
        order_received_date: '2024-01-07T11:30:00Z',
        order_status: 'en_route',
        order_timezone: 'America/Chicago',
        order_type: 'Expedited',
        order_updated: '2024-01-18T14:00:00Z',
        origin_city: 'Dallas',
        origin_name: 'Dallas Intermodal Terminal',
        origin_state: 'TX',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: '$150.00',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, BOL, Customs',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'POD',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'None',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'Detention',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'Fuel Surcharge',
        pending_carrier_accessorials: 'Detention',
        pending_shipper_accessorials: 'Storage',
        railroads: 'UP',
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB45672',
                optimized: 'MB45672',
                _id: '5bbd231b4c202300122ef001',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO78934',
                optimized: 'DO78934',
                _id: '5bbd231b4c202300122ef002',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Port-to-Door',
        shipment_id: 'SHP-2024-002-A',
        shipper: 'Global Logistics Inc',
        shipper_accessorial_total: 300.0,
        shipper_account_support_agent: 'Mark Thompson',
        shipper_account_support_agent_tier2: 'Susan Clark',
        shipper_billing_rep: 'James Wilson',
        shipper_chassis_total: 75.0,
        shipper_cost_total: 3200.0,
        shipper_customer_success_manager: 'Patricia Moore',
        shipper_data_entry_agent: 'Daniel Kim',
        shipper_demurrage_total: 125.0,
        shipper_fsc_total: 320.0,
        shipper_linehaul: 2300.0,
        shipper_ops_group: 'Central Ops',
        shipper_ops_manager: 'Steven Harris',
        shipper_other_accessorial_total: 180.0,
        shipper_sales_rep: 'Michelle Young',
        shipper_storage_total: 0.0,
        shipper_total: 3200.0,
        shorthaul_ops_customer_success: 'Brian Scott',
        shorthaul_ops_operations_manager: 'Laura Adams',
        standard_reference_numbers_booking_number: 'BK-2024-002',
        standard_reference_numbers_category: 'Import',
        standard_reference_numbers_delivery_order: 'DO-2024-002',
        standard_reference_numbers_final_destination: 'Atlanta, GA',
        standard_reference_numbers_master_bol: 'MBOL-23456',
        standard_reference_numbers_mo_number: 'MO-2024-002',
        standard_reference_numbers_mode: 'Intermodal',
        standard_reference_numbers_po_number: 'PO-23456',
        standard_reference_numbers_work_order_number: 'WO-2024-002',
        steamship: 'COSCO',
        team_commercial_account_manager: 'Richard King',
        team_commercial_sales_rep: 'Elizabeth Wright',
        team_drayage_ops_customer_success: 'Jason Turner',
        team_drayage_ops_data_entry: 'Angela Rodriguez',
        total: 3200.0,
        total_invoiced: 0.0,
        train: 'UP-ZDATL',
        unbilled_approved: 150.0,
        unbilled_charges: 300.0,
        unbilled_pending: 150.0,
        vendor_total: 2400.0,
        weight: 38500,
    },
    {
        _id: '3',
        order_id: 'ORD-2024-003',
        origin: 'Seattle, WA',
        destination: 'San Francisco, CA',
        margin: 600.0,
        vessel: 'EVER GOLDEN',
        accounting_review_date: '2024-01-20T11:30:00Z',
        automated_billing_evaluated_paused_timestamp: '2024-01-12T09:15:00Z',
        automated_billing_evaluation_paused: 'Yes',
        automated_billing_evaluation_paused_reason: 'Pending accessorial review',
        base_rate: 1100.0,
        bco: 'TechCorp',
        billing_status_billing_status: 'pending_review',
        billing_status_billing_status_updated_at: '2024-01-19T15:45:00Z',
        billing_status_invoice_grouping: 'Monthly',
        billing_status_override_billing_status_note: 'Customer dispute under review',
        billing_status_override_billing_status_reason_codes: 'DISP-001',
        billing_status_pending_accessorial_evaluation: 'In Progress',
        billing_status_override_billing_status: 'hold',
        cargo_description: 'Computer Hardware - Servers',
        carrier_accessorial_total: 100.0,
        carrier_cost_total: 1200.0,
        carrier_fsc_total: 120.0,
        carrier_linehaul: 900.0,
        carrier_other_accessorial_total: 80.0,
        carrier_total: 1200.0,
        container_number: 'EVRU5554321',
        created_at: '2024-01-10T12:00:00Z',
        created_by: 'alex.wang@cargomatic.com',
        date_created: '2024-01-10T11:30:00Z',
        destination_city: 'San Francisco',
        destination_name: 'SF Tech Campus',
        destination_state: 'CA',
        discussion: 'High-value cargo - signature required',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: '2024-02-20T11:30:00Z',
        market: 'Pacific Northwest',
        missing_docs_report: 'None',
        mode: 'Truck',
        move_type: 'Domestic',
        order_carrier: 'Schneider National',
        order_received_date: '2024-01-09T11:30:00Z',
        order_status: 'complete',
        order_timezone: 'America/Los_Angeles',
        order_type: 'White Glove',
        order_updated: '2024-01-20T10:00:00Z',
        origin_city: 'Seattle',
        origin_name: 'Port of Seattle',
        origin_state: 'WA',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: 'None',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, Signature',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'None',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#, ASN#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'ASN#',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'None',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'Liftgate',
        pending_carrier_accessorials: 'None',
        pending_shipper_accessorials: 'Liftgate',
        railroads: null,
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB67891',
                optimized: 'MB67891',
                _id: '5bbd231b4c202300122ef003',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO34521',
                optimized: 'DO34521',
                _id: '5bbd231b4c202300122ef004',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Door-to-Door',
        shipment_id: 'SHP-2024-003-A',
        shipper: 'TechCorp Solutions',
        shipper_accessorial_total: 150.0,
        shipper_account_support_agent: 'Rachel Green',
        shipper_account_support_agent_tier2: 'Paul Martinez',
        shipper_billing_rep: 'Monica Geller',
        shipper_chassis_total: 0.0,
        shipper_cost_total: 1800.0,
        shipper_customer_success_manager: 'Ross Geller',
        shipper_data_entry_agent: 'Phoebe Buffay',
        shipper_demurrage_total: 0.0,
        shipper_fsc_total: 180.0,
        shipper_linehaul: 1400.0,
        shipper_ops_group: 'West Coast Ops',
        shipper_ops_manager: 'Chandler Bing',
        shipper_other_accessorial_total: 70.0,
        shipper_sales_rep: 'Joey Tribbiani',
        shipper_storage_total: 0.0,
        shipper_total: 1800.0,
        shorthaul_ops_customer_success: 'Janice Litman',
        shorthaul_ops_operations_manager: 'Gunther Central',
        standard_reference_numbers_booking_number: 'BK-2024-003',
        standard_reference_numbers_category: 'Domestic',
        standard_reference_numbers_delivery_order: 'DO-2024-003',
        standard_reference_numbers_final_destination: 'San Francisco, CA',
        standard_reference_numbers_master_bol: 'MBOL-34567',
        standard_reference_numbers_mo_number: 'MO-2024-003',
        standard_reference_numbers_mode: 'Truck',
        standard_reference_numbers_po_number: 'PO-34567',
        standard_reference_numbers_work_order_number: 'WO-2024-003',
        steamship: 'Evergreen',
        team_commercial_account_manager: 'Ben Wyatt',
        team_commercial_sales_rep: 'Leslie Knope',
        team_drayage_ops_customer_success: 'Ann Perkins',
        team_drayage_ops_data_entry: 'Tom Haverford',
        total: 1800.0,
        total_invoiced: 1200.0,
        train: null,
        unbilled_approved: 300.0,
        unbilled_charges: 600.0,
        unbilled_pending: 300.0,
        vendor_total: 1200.0,
        weight: 15000,
    },
    {
        _id: '4',
        order_id: 'ORD-2024-004',
        origin: 'Chicago, IL',
        destination: 'Detroit, MI',
        margin: 900.0,
        vessel: 'OOCL HONG KONG',
        accounting_review_date: null,
        automated_billing_evaluated_paused_timestamp: null,
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 3200.0,
        bco: 'Manufacturing Co',
        billing_status_billing_status: 'customer_portal',
        billing_status_billing_status_updated_at: '2024-01-21T08:00:00Z',
        billing_status_invoice_grouping: 'Weekly',
        billing_status_override_billing_status_note: null,
        billing_status_override_billing_status_reason_codes: null,
        billing_status_pending_accessorial_evaluation: 'Not Started',
        billing_status_override_billing_status: 'canceled',
        cargo_description: 'Manufacturing Equipment',
        carrier_accessorial_total: 400.0,
        carrier_cost_total: 3600.0,
        carrier_fsc_total: 360.0,
        carrier_linehaul: 2600.0,
        carrier_other_accessorial_total: 240.0,
        carrier_total: 3600.0,
        container_number: 'OOLU3338889',
        created_at: '2024-01-15T09:00:00Z',
        created_by: 'bob.builder@cargomatic.com',
        date_created: '2024-01-15T11:30:00Z',
        destination_city: 'Detroit',
        destination_name: 'Detroit Assembly Plant',
        destination_state: 'MI',
        discussion: 'Oversized load - special permits required',
        hazmat_class: '3',
        hazmat_description: 'Flammable Liquids - Lubricants',
        hazmat_packaging: 'Drums - UN1A1',
        invoice_cliff_date: '2024-02-25T11:30:00Z',
        market: 'Midwest',
        missing_docs_report: 'BOL Missing, Customs Pending',
        mode: 'Rail',
        move_type: 'Import',
        order_carrier: 'J.B. Hunt',
        order_received_date: '2024-01-14T11:30:00Z',
        order_status: 'booking',
        order_timezone: 'America/Chicago',
        order_type: 'Hazmat',
        order_updated: '2024-01-21T12:00:00Z',
        origin_city: 'Chicago',
        origin_name: 'Chicago Rail Yard',
        origin_state: 'IL',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: '$850.00',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, BOL, Hazmat Cert, Customs',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'BOL, Customs',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#, Hazmat#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'Hazmat#',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'Hazmat Fee',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'Hazmat Fee, Permit Fee',
        pending_carrier_accessorials: 'Hazmat Surcharge',
        pending_shipper_accessorials: 'Hazmat Fee, Permit Fee',
        railroads: 'CSX, NS',
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB89123',
                optimized: 'MB89123',
                _id: '5bbd231b4c202300122ef005',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO56789',
                optimized: 'DO56789',
                _id: '5bbd231b4c202300122ef006',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Ramp-to-Door',
        shipment_id: 'SHP-2024-004-A',
        shipper: 'Manufacturing Co',
        shipper_accessorial_total: 600.0,
        shipper_account_support_agent: 'Walter White',
        shipper_account_support_agent_tier2: 'Jesse Pinkman',
        shipper_billing_rep: 'Skyler White',
        shipper_chassis_total: 100.0,
        shipper_cost_total: 4500.0,
        shipper_customer_success_manager: 'Hank Schrader',
        shipper_data_entry_agent: 'Marie Schrader',
        shipper_demurrage_total: 200.0,
        shipper_fsc_total: 450.0,
        shipper_linehaul: 3100.0,
        shipper_ops_group: 'Central Ops',
        shipper_ops_manager: 'Gustavo Fring',
        shipper_other_accessorial_total: 250.0,
        shipper_sales_rep: 'Saul Goodman',
        shipper_storage_total: 0.0,
        shipper_total: 4500.0,
        shorthaul_ops_customer_success: 'Mike Ehrmantraut',
        shorthaul_ops_operations_manager: 'Lydia Rodarte',
        standard_reference_numbers_booking_number: 'BK-2024-004',
        standard_reference_numbers_category: 'Import - Hazmat',
        standard_reference_numbers_delivery_order: 'DO-2024-004',
        standard_reference_numbers_final_destination: 'Detroit, MI',
        standard_reference_numbers_master_bol: 'MBOL-45678',
        standard_reference_numbers_mo_number: 'MO-2024-004',
        standard_reference_numbers_mode: 'Rail',
        standard_reference_numbers_po_number: 'PO-45678',
        standard_reference_numbers_work_order_number: 'WO-2024-004',
        steamship: 'OOCL',
        team_commercial_account_manager: 'Gus Ring',
        team_commercial_sales_rep: 'Jimmy McGill',
        team_drayage_ops_customer_success: 'Kim Wexler',
        team_drayage_ops_data_entry: 'Howard Hamlin',
        total: 4500.0,
        total_invoiced: 0.0,
        train: 'CSX-Q-CHI-DET',
        unbilled_approved: 500.0,
        unbilled_charges: 850.0,
        unbilled_pending: 350.0,
        vendor_total: 3600.0,
        weight: 65000,
    },
    {
        _id: '5',
        order_id: 'ORD-2024-005',
        origin: 'Miami, FL',
        destination: 'Orlando, FL',
        margin: 250.0,
        vessel: 'MAERSK ESSEX',
        accounting_review_date: '2024-01-22T11:30:00Z',
        automated_billing_evaluated_paused_timestamp: null,
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 850.0,
        bco: 'Retail Partners',
        billing_status_billing_status: 'awaiting_billable_event',
        billing_status_billing_status_updated_at: '2024-01-20T16:00:00Z',
        billing_status_invoice_grouping: 'Daily',
        billing_status_override_billing_status_note: 'Order cancelled by customer',
        billing_status_override_billing_status_reason_codes: 'CANC-001',
        billing_status_pending_accessorial_evaluation: 'N/A',
        billing_status_override_billing_status: 'canceled',
        cargo_description: 'Retail Merchandise - Apparel',
        carrier_accessorial_total: 100.0,
        carrier_cost_total: 950.0,
        carrier_fsc_total: 95.0,
        carrier_linehaul: 700.0,
        carrier_other_accessorial_total: 55.0,
        carrier_total: 950.0,
        container_number: 'MAEU4447778',
        created_at: '2024-01-12T14:00:00Z',
        created_by: 'carol.jones@cargomatic.com',
        date_created: '2024-01-12T11:30:00Z',
        destination_city: 'Orlando',
        destination_name: 'Orlando Distribution Center',
        destination_state: 'FL',
        discussion: 'CANCELLED - Customer changed plans',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: null,
        market: 'Florida',
        missing_docs_report: 'N/A - Cancelled',
        mode: 'Truck',
        move_type: 'Import',
        order_carrier: 'Ryder',
        order_received_date: '2024-01-11T11:30:00Z',
        order_status: 'canceled',
        order_timezone: 'America/New_York',
        order_type: 'Standard',
        order_updated: '2024-01-20T16:00:00Z',
        origin_city: 'Miami',
        origin_name: 'Port of Miami',
        origin_state: 'FL',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: 'N/A',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'N/A',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'N/A',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'N/A',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'N/A',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'N/A',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'N/A',
        pending_carrier_accessorials: 'N/A',
        pending_shipper_accessorials: 'N/A',
        railroads: null,
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB12345',
                optimized: 'MB12345',
                _id: '5bbd231b4c202300122ef007',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO98765',
                optimized: 'DO98765',
                _id: '5bbd231b4c202300122ef008',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Port-to-Door',
        shipment_id: 'SHP-2024-005-A',
        shipper: 'Retail Partners LLC',
        shipper_accessorial_total: 0.0,
        shipper_account_support_agent: 'Tony Stark',
        shipper_account_support_agent_tier2: 'Pepper Potts',
        shipper_billing_rep: 'Happy Hogan',
        shipper_chassis_total: 0.0,
        shipper_cost_total: 0.0,
        shipper_customer_success_manager: 'Nick Fury',
        shipper_data_entry_agent: 'Maria Hill',
        shipper_demurrage_total: 0.0,
        shipper_fsc_total: 0.0,
        shipper_linehaul: 0.0,
        shipper_ops_group: 'East Coast Ops',
        shipper_ops_manager: 'Phil Coulson',
        shipper_other_accessorial_total: 0.0,
        shipper_sales_rep: 'Natasha Romanoff',
        shipper_storage_total: 0.0,
        shipper_total: 0.0,
        shorthaul_ops_customer_success: 'Clint Barton',
        shorthaul_ops_operations_manager: 'Steve Rogers',
        standard_reference_numbers_booking_number: 'BK-2024-005',
        standard_reference_numbers_category: 'Import',
        standard_reference_numbers_delivery_order: 'DO-2024-005',
        standard_reference_numbers_final_destination: 'Orlando, FL',
        standard_reference_numbers_master_bol: 'MBOL-56789',
        standard_reference_numbers_mo_number: 'MO-2024-005',
        standard_reference_numbers_mode: 'Truck',
        standard_reference_numbers_po_number: 'PO-56789',
        standard_reference_numbers_work_order_number: 'WO-2024-005',
        steamship: 'Maersk',
        team_commercial_account_manager: 'Bruce Banner',
        team_commercial_sales_rep: 'Thor Odinson',
        team_drayage_ops_customer_success: 'Wanda Maximoff',
        team_drayage_ops_data_entry: 'Vision Android',
        total: 0.0,
        total_invoiced: 0.0,
        train: null,
        unbilled_approved: 0.0,
        unbilled_charges: 0.0,
        unbilled_pending: 0.0,
        vendor_total: 0.0,
        weight: 0,
    },
    {
        _id: '6',
        order_id: 'ORD-2024-006',
        origin: 'Houston, TX',
        destination: 'New Orleans, LA',
        margin: 700.0,
        vessel: 'CMA CGM MARCO POLO',
        accounting_review_date: '2024-01-25T11:30:00Z',
        automated_billing_evaluated_paused_timestamp: null,
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 1900.0,
        bco: 'Supply Chain Sol',
        billing_status_billing_status: 'ready_to_bill',
        billing_status_billing_status_updated_at: '2024-01-24T10:00:00Z',
        billing_status_invoice_grouping: 'Weekly',
        billing_status_override_billing_status_note: null,
        billing_status_override_billing_status_reason_codes: null,
        billing_status_pending_accessorial_evaluation: 'Complete',
        billing_status_override_billing_status: null,
        cargo_description: 'Industrial Chemicals - Non-Hazmat',
        carrier_accessorial_total: 200.0,
        carrier_cost_total: 2100.0,
        carrier_fsc_total: 210.0,
        carrier_linehaul: 1550.0,
        carrier_other_accessorial_total: 140.0,
        carrier_total: 2100.0,
        container_number: 'CMAU9988776',
        created_at: '2024-01-18T11:00:00Z',
        created_by: 'david.miller@cargomatic.com',
        date_created: '2024-01-18T11:30:00Z',
        destination_city: 'New Orleans',
        destination_name: 'NOLA Chemical Plant',
        destination_state: 'LA',
        discussion: 'Temperature controlled required',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: '2024-02-28T11:30:00Z',
        market: 'Gulf Coast',
        missing_docs_report: 'None',
        mode: 'Truck',
        move_type: 'Import',
        order_carrier: 'Werner Enterprises',
        order_received_date: '2024-01-17T11:30:00Z',
        order_status: 'booked',
        order_timezone: 'America/Chicago',
        order_type: 'Temperature Controlled',
        order_updated: '2024-01-25T09:00:00Z',
        origin_city: 'Houston',
        origin_name: 'Port of Houston',
        origin_state: 'TX',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: 'None',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, BOL, Temp Log',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'None',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'None',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'None',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'None',
        pending_carrier_accessorials: 'None',
        pending_shipper_accessorials: 'None',
        railroads: null,
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB54321',
                optimized: 'MB54321',
                _id: '5bbd231b4c202300122ef009',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO11223',
                optimized: 'DO11223',
                _id: '5bbd231b4c202300122ef00a',
                hidden: false,
                editable: true,
            },
            {
                _id: '68ed6a393a947c4c8d616bf2',
                name: 'equipment_id',
                value: 'CNTR-123123',
                hidden: false,
                primary: false,
                editable: false,
                optimized: 'CNTR-123123',
            },
        ],
        service_type: 'Port-to-Door',
        shipment_id: 'SHP-2024-006-A',
        shipper: 'Supply Chain Solutions',
        shipper_accessorial_total: 250.0,
        shipper_account_support_agent: 'Peter Parker',
        shipper_account_support_agent_tier2: 'Mary Jane Watson',
        shipper_billing_rep: 'Gwen Stacy',
        shipper_chassis_total: 50.0,
        shipper_cost_total: 2800.0,
        shipper_customer_success_manager: 'Miles Morales',
        shipper_data_entry_agent: 'Ned Leeds',
        shipper_demurrage_total: 0.0,
        shipper_fsc_total: 280.0,
        shipper_linehaul: 2100.0,
        shipper_ops_group: 'Gulf Ops',
        shipper_ops_manager: 'Otto Octavius',
        shipper_other_accessorial_total: 120.0,
        shipper_sales_rep: 'Norman Osborn',
        shipper_storage_total: 0.0,
        shipper_total: 2800.0,
        shorthaul_ops_customer_success: 'Eddie Brock',
        shorthaul_ops_operations_manager: 'Curt Connors',
        standard_reference_numbers_booking_number: 'BK-2024-006',
        standard_reference_numbers_category: 'Import',
        standard_reference_numbers_delivery_order: 'DO-2024-006',
        standard_reference_numbers_final_destination: 'New Orleans, LA',
        standard_reference_numbers_master_bol: 'MBOL-67890',
        standard_reference_numbers_mo_number: 'MO-2024-006',
        standard_reference_numbers_mode: 'Truck',
        standard_reference_numbers_po_number: 'PO-67890',
        standard_reference_numbers_work_order_number: 'WO-2024-006',
        steamship: 'CMA CGM',
        team_commercial_account_manager: 'Harry Osborn',
        team_commercial_sales_rep: 'Flash Thompson',
        team_drayage_ops_customer_success: 'Betty Brant',
        team_drayage_ops_data_entry: 'J. Jonah Jameson',
        total: 2800.0,
        total_invoiced: 2800.0,
        train: null,
        unbilled_approved: 0.0,
        unbilled_charges: 0.0,
        unbilled_pending: 0.0,
        vendor_total: 2100.0,
        weight: 44000,
    },
    {
        _id: '7',
        order_id: 'ORD-2024-007',
        origin: 'Oakland, CA',
        destination: 'Las Vegas, NV',
        margin: 550.0,
        vessel: 'MSC OSCAR',
        accounting_review_date: '2024-01-28T11:30:00Z',
        automated_billing_evaluated_paused_timestamp: null,
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 1300.0,
        bco: 'Logistics Express',
        billing_status_billing_status: 'invoiced',
        billing_status_billing_status_updated_at: '2024-01-27T14:30:00Z',
        billing_status_invoice_grouping: 'Daily',
        billing_status_override_billing_status_note: null,
        billing_status_override_billing_status_reason_codes: null,
        billing_status_pending_accessorial_evaluation: 'Complete',
        billing_status_override_billing_status: null,
        cargo_description: 'Casino Equipment',
        carrier_accessorial_total: 100.0,
        carrier_cost_total: 1400.0,
        carrier_fsc_total: 140.0,
        carrier_linehaul: 1100.0,
        carrier_other_accessorial_total: 60.0,
        carrier_total: 1400.0,
        container_number: 'MSKU7788990',
        created_at: '2024-01-22T08:30:00Z',
        created_by: 'eva.santos@cargomatic.com',
        date_created: '2024-01-22T11:30:00Z',
        destination_city: 'Las Vegas',
        destination_name: 'Vegas Convention Center',
        destination_state: 'NV',
        discussion: 'Trade show delivery - time sensitive',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: '2024-03-01T11:30:00Z',
        market: 'Southwest',
        missing_docs_report: 'None',
        mode: 'Truck',
        move_type: 'Import',
        order_carrier: 'Old Dominion',
        order_received_date: '2024-01-21T11:30:00Z',
        order_status: 'complete',
        order_timezone: 'America/Los_Angeles',
        order_type: 'Trade Show',
        order_updated: '2024-01-28T11:00:00Z',
        origin_city: 'Oakland',
        origin_name: 'Port of Oakland',
        origin_state: 'CA',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: 'None',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, BOL',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'None',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#, Event#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'None',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'None',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'None',
        pending_carrier_accessorials: 'None',
        pending_shipper_accessorials: 'None',
        railroads: null,
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB78901',
                optimized: 'MB78901',
                _id: '5bbd231b4c202300122ef00b',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO44556',
                optimized: 'DO44556',
                _id: '5bbd231b4c202300122ef00c',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Door-to-Door',
        shipment_id: 'SHP-2024-007-A',
        shipper: 'Logistics Express Inc',
        shipper_accessorial_total: 100.0,
        shipper_account_support_agent: 'Clark Kent',
        shipper_account_support_agent_tier2: 'Lois Lane',
        shipper_billing_rep: 'Jimmy Olsen',
        shipper_chassis_total: 50.0,
        shipper_cost_total: 1950.0,
        shipper_customer_success_manager: 'Perry White',
        shipper_data_entry_agent: 'Cat Grant',
        shipper_demurrage_total: 0.0,
        shipper_fsc_total: 195.0,
        shipper_linehaul: 1500.0,
        shipper_ops_group: 'West Coast Ops',
        shipper_ops_manager: 'Lex Luthor',
        shipper_other_accessorial_total: 105.0,
        shipper_sales_rep: 'Bruce Wayne',
        shipper_storage_total: 0.0,
        shipper_total: 1950.0,
        shorthaul_ops_customer_success: 'Diana Prince',
        shorthaul_ops_operations_manager: 'Barry Allen',
        standard_reference_numbers_booking_number: 'BK-2024-007',
        standard_reference_numbers_category: 'Import',
        standard_reference_numbers_delivery_order: 'DO-2024-007',
        standard_reference_numbers_final_destination: 'Las Vegas, NV',
        standard_reference_numbers_master_bol: 'MBOL-78901',
        standard_reference_numbers_mo_number: 'MO-2024-007',
        standard_reference_numbers_mode: 'Truck',
        standard_reference_numbers_po_number: 'PO-78901',
        standard_reference_numbers_work_order_number: 'WO-2024-007',
        steamship: 'MSC',
        team_commercial_account_manager: 'Arthur Curry',
        team_commercial_sales_rep: 'Victor Stone',
        team_drayage_ops_customer_success: 'Hal Jordan',
        team_drayage_ops_data_entry: 'John Stewart',
        total: 1950.0,
        total_invoiced: 1950.0,
        train: null,
        unbilled_approved: 0.0,
        unbilled_charges: 0.0,
        unbilled_pending: 0.0,
        vendor_total: 1400.0,
        weight: 28000,
    },
    {
        _id: '8',
        order_id: 'ORD-2024-008',
        origin: 'Baltimore, MD',
        destination: 'Washington, DC',
        margin: 400.0,
        vessel: 'EVER GLOBE',
        accounting_review_date: '2024-01-30T11:30:00Z',
        automated_billing_evaluated_paused_timestamp: null,
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 1100.0,
        bco: 'Metro Distribution',
        billing_status_billing_status: 'billing_hold',
        billing_status_billing_status_updated_at: '2024-01-29T16:00:00Z',
        billing_status_invoice_grouping: 'Weekly',
        billing_status_override_billing_status_note: null,
        billing_status_override_billing_status_reason_codes: null,
        billing_status_pending_accessorial_evaluation: 'Complete',
        billing_status_override_billing_status: null,
        cargo_description: 'Office Furniture',
        carrier_accessorial_total: 100.0,
        carrier_cost_total: 1200.0,
        carrier_fsc_total: 120.0,
        carrier_linehaul: 900.0,
        carrier_other_accessorial_total: 80.0,
        carrier_total: 1200.0,
        container_number: 'EVRU3344556',
        created_at: '2024-01-25T10:00:00Z',
        created_by: 'frank.garcia@cargomatic.com',
        date_created: '2024-01-25T11:30:00Z',
        destination_city: 'Washington',
        destination_name: 'DC Government Center',
        destination_state: 'DC',
        discussion: 'Government contract - strict delivery window',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: '2024-03-05T11:30:00Z',
        market: 'Mid-Atlantic',
        missing_docs_report: 'None',
        mode: 'Truck',
        move_type: 'Import',
        order_carrier: 'Saia LTL',
        order_received_date: '2024-01-24T11:30:00Z',
        order_status: 'complete',
        order_timezone: 'America/New_York',
        order_type: 'Government',
        order_updated: '2024-01-30T08:00:00Z',
        origin_city: 'Baltimore',
        origin_name: 'Port of Baltimore',
        origin_state: 'MD',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: 'None',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, BOL, Gov Form',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'None',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#, Contract#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'None',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'None',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'None',
        pending_carrier_accessorials: 'None',
        pending_shipper_accessorials: 'None',
        railroads: null,
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB89012',
                optimized: 'MB89012',
                _id: '5bbd231b4c202300122ef00d',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO77889',
                optimized: 'DO77889',
                _id: '5bbd231b4c202300122ef00e',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Door-to-Door',
        shipment_id: 'SHP-2024-008-A',
        shipper: 'Metro Distribution Co',
        shipper_accessorial_total: 100.0,
        shipper_account_support_agent: 'Oliver Queen',
        shipper_account_support_agent_tier2: 'Felicity Smoak',
        shipper_billing_rep: 'John Diggle',
        shipper_chassis_total: 0.0,
        shipper_cost_total: 1600.0,
        shipper_customer_success_manager: 'Laurel Lance',
        shipper_data_entry_agent: 'Thea Queen',
        shipper_demurrage_total: 0.0,
        shipper_fsc_total: 160.0,
        shipper_linehaul: 1250.0,
        shipper_ops_group: 'East Coast Ops',
        shipper_ops_manager: 'Malcolm Merlyn',
        shipper_other_accessorial_total: 90.0,
        shipper_sales_rep: 'Roy Harper',
        shipper_storage_total: 0.0,
        shipper_total: 1600.0,
        shorthaul_ops_customer_success: 'Sara Lance',
        shorthaul_ops_operations_manager: 'Ray Palmer',
        standard_reference_numbers_booking_number: 'BK-2024-008',
        standard_reference_numbers_category: 'Import',
        standard_reference_numbers_delivery_order: 'DO-2024-008',
        standard_reference_numbers_final_destination: 'Washington, DC',
        standard_reference_numbers_master_bol: 'MBOL-89012',
        standard_reference_numbers_mo_number: 'MO-2024-008',
        standard_reference_numbers_mode: 'Truck',
        standard_reference_numbers_po_number: 'PO-89012',
        standard_reference_numbers_work_order_number: 'WO-2024-008',
        steamship: 'Evergreen',
        team_commercial_account_manager: 'Damien Darhk',
        team_commercial_sales_rep: 'Slade Wilson',
        team_drayage_ops_customer_success: 'Curtis Holt',
        team_drayage_ops_data_entry: 'Rene Ramirez',
        total: 1600.0,
        total_invoiced: 1600.0,
        train: null,
        unbilled_approved: 0.0,
        unbilled_charges: 0.0,
        unbilled_pending: 0.0,
        vendor_total: 1200.0,
        weight: 18000,
    },
    {
        _id: '9',
        order_id: 'ORD-2024-009',
        origin: 'Portland, OR',
        destination: 'Sacramento, CA',
        margin: 700.0,
        vessel: 'OOCL BEIJING',
        accounting_review_date: null,
        automated_billing_evaluated_paused_timestamp: null,
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 2600.0,
        bco: 'Industrial Freight',
        billing_status_billing_status: 'not_ready',
        billing_status_billing_status_updated_at: '2024-02-01T09:00:00Z',
        billing_status_invoice_grouping: 'Monthly',
        billing_status_override_billing_status_note: null,
        billing_status_override_billing_status_reason_codes: null,
        billing_status_pending_accessorial_evaluation: 'Pending',
        billing_status_override_billing_status: null,
        cargo_description: 'Lumber and Wood Products',
        carrier_accessorial_total: 300.0,
        carrier_cost_total: 2900.0,
        carrier_fsc_total: 290.0,
        carrier_linehaul: 2100.0,
        carrier_other_accessorial_total: 210.0,
        carrier_total: 2900.0,
        container_number: 'OOLU8899001',
        created_at: '2024-01-28T13:00:00Z',
        created_by: 'grace.lee@cargomatic.com',
        date_created: '2024-01-28T11:30:00Z',
        destination_city: 'Sacramento',
        destination_name: 'Sacramento Lumber Yard',
        destination_state: 'CA',
        discussion: 'Flatbed required - oversized load',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: '2024-03-10T11:30:00Z',
        market: 'Pacific Northwest',
        missing_docs_report: 'Weight Ticket Pending',
        mode: 'Truck',
        move_type: 'Domestic',
        order_carrier: 'Landstar',
        order_received_date: '2024-01-27T11:30:00Z',
        order_status: 'booking',
        order_timezone: 'America/Los_Angeles',
        order_type: 'Flatbed',
        order_updated: '2024-02-01T10:00:00Z',
        origin_city: 'Portland',
        origin_name: 'Portland Lumber Mill',
        origin_state: 'OR',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: '$400.00',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, BOL, Weight Ticket',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'Weight Ticket',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#, Mill#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'Mill#',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'Tarping',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'Tarping, Strapping',
        pending_carrier_accessorials: 'Tarping',
        pending_shipper_accessorials: 'Strapping',
        railroads: null,
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB90123',
                optimized: 'MB90123',
                _id: '5bbd231b4c202300122ef00f',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO33445',
                optimized: 'DO33445',
                _id: '5bbd231b4c202300122ef010',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Door-to-Door',
        shipment_id: 'SHP-2024-009-A',
        shipper: 'Industrial Freight LLC',
        shipper_accessorial_total: 400.0,
        shipper_account_support_agent: 'Kara Danvers',
        shipper_account_support_agent_tier2: 'Alex Danvers',
        shipper_billing_rep: 'James Olsen',
        shipper_chassis_total: 0.0,
        shipper_cost_total: 3600.0,
        shipper_customer_success_manager: 'Winn Schott',
        shipper_data_entry_agent: 'Lena Luthor',
        shipper_demurrage_total: 0.0,
        shipper_fsc_total: 360.0,
        shipper_linehaul: 2700.0,
        shipper_ops_group: 'West Coast Ops',
        shipper_ops_manager: 'Hank Henshaw',
        shipper_other_accessorial_total: 140.0,
        shipper_sales_rep: 'Cat Grant Jr',
        shipper_storage_total: 0.0,
        shipper_total: 3600.0,
        shorthaul_ops_customer_success: 'Mon-El Prince',
        shorthaul_ops_operations_manager: 'Jonn Jonzz',
        standard_reference_numbers_booking_number: 'BK-2024-009',
        standard_reference_numbers_category: 'Domestic',
        standard_reference_numbers_delivery_order: 'DO-2024-009',
        standard_reference_numbers_final_destination: 'Sacramento, CA',
        standard_reference_numbers_master_bol: 'MBOL-90123',
        standard_reference_numbers_mo_number: 'MO-2024-009',
        standard_reference_numbers_mode: 'Truck',
        standard_reference_numbers_po_number: 'PO-90123',
        standard_reference_numbers_work_order_number: 'WO-2024-009',
        steamship: 'OOCL',
        team_commercial_account_manager: 'Nia Nal',
        team_commercial_sales_rep: 'Brainy Dox',
        team_drayage_ops_customer_success: 'Kelly Olsen',
        team_drayage_ops_data_entry: 'Andrea Rojas',
        total: 3600.0,
        total_invoiced: 0.0,
        train: null,
        unbilled_approved: 200.0,
        unbilled_charges: 400.0,
        unbilled_pending: 200.0,
        vendor_total: 2900.0,
        weight: 52000,
    },
    {
        _id: '10',
        order_id: 'ORD-2024-010',
        origin: 'Jacksonville, FL',
        destination: 'Savannah, GA',
        margin: 550.0,
        vessel: 'MAERSK ALABAMA',
        accounting_review_date: '2024-02-02T11:30:00Z',
        automated_billing_evaluated_paused_timestamp: null,
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 1500.0,
        bco: 'Coastal Shipping',
        billing_status_billing_status: 'ready_to_bill',
        billing_status_billing_status_updated_at: '2024-02-01T15:00:00Z',
        billing_status_invoice_grouping: 'Weekly',
        billing_status_override_billing_status_note: null,
        billing_status_override_billing_status_reason_codes: null,
        billing_status_pending_accessorial_evaluation: 'Complete',
        billing_status_override_billing_status: null,
        cargo_description: 'Paper Products',
        carrier_accessorial_total: 150.0,
        carrier_cost_total: 1650.0,
        carrier_fsc_total: 165.0,
        carrier_linehaul: 1250.0,
        carrier_other_accessorial_total: 85.0,
        carrier_total: 1650.0,
        container_number: 'MAEU2233445',
        created_at: '2024-01-30T09:00:00Z',
        created_by: 'henry.adams@cargomatic.com',
        date_created: '2024-01-30T11:30:00Z',
        destination_city: 'Savannah',
        destination_name: 'Port of Savannah',
        destination_state: 'GA',
        discussion: 'Standard shipment - no special requirements',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: '2024-03-15T11:30:00Z',
        market: 'Southeast',
        missing_docs_report: 'None',
        mode: 'Truck',
        move_type: 'Export',
        order_carrier: 'ABF Freight',
        order_received_date: '2024-01-29T11:30:00Z',
        order_status: 'booked',
        order_timezone: 'America/New_York',
        order_type: 'Standard',
        order_updated: '2024-02-02T08:00:00Z',
        origin_city: 'Jacksonville',
        origin_name: 'JAXPORT',
        origin_state: 'FL',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: 'None',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, BOL',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'None',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'None',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'None',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'None',
        pending_carrier_accessorials: 'None',
        pending_shipper_accessorials: 'None',
        railroads: null,
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB01234',
                optimized: 'MB01234',
                _id: '5bbd231b4c202300122ef011',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO66778',
                optimized: 'DO66778',
                _id: '5bbd231b4c202300122ef012',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Door-to-Port',
        shipment_id: 'SHP-2024-010-A',
        shipper: 'Coastal Shipping Group',
        shipper_accessorial_total: 200.0,
        shipper_account_support_agent: 'Matt Murdock',
        shipper_account_support_agent_tier2: 'Foggy Nelson',
        shipper_billing_rep: 'Karen Page',
        shipper_chassis_total: 50.0,
        shipper_cost_total: 2200.0,
        shipper_customer_success_manager: 'Claire Temple',
        shipper_data_entry_agent: 'Marci Stahl',
        shipper_demurrage_total: 0.0,
        shipper_fsc_total: 220.0,
        shipper_linehaul: 1650.0,
        shipper_ops_group: 'East Coast Ops',
        shipper_ops_manager: 'Wilson Fisk',
        shipper_other_accessorial_total: 80.0,
        shipper_sales_rep: 'Elektra Natchios',
        shipper_storage_total: 0.0,
        shipper_total: 2200.0,
        shorthaul_ops_customer_success: 'Frank Castle',
        shorthaul_ops_operations_manager: 'Stick Master',
        standard_reference_numbers_booking_number: 'BK-2024-010',
        standard_reference_numbers_category: 'Export',
        standard_reference_numbers_delivery_order: 'DO-2024-010',
        standard_reference_numbers_final_destination: 'Savannah, GA',
        standard_reference_numbers_master_bol: 'MBOL-01234',
        standard_reference_numbers_mo_number: 'MO-2024-010',
        standard_reference_numbers_mode: 'Truck',
        standard_reference_numbers_po_number: 'PO-01234',
        standard_reference_numbers_work_order_number: 'WO-2024-010',
        steamship: 'Maersk',
        team_commercial_account_manager: 'Jessica Jones',
        team_commercial_sales_rep: 'Luke Cage',
        team_drayage_ops_customer_success: 'Danny Rand',
        team_drayage_ops_data_entry: 'Colleen Wing',
        total: 2200.0,
        total_invoiced: 0.0,
        train: null,
        unbilled_approved: 0.0,
        unbilled_charges: 0.0,
        unbilled_pending: 0.0,
        vendor_total: 1650.0,
        weight: 35000,
    },
    {
        _id: '11',
        order_id: 'ORD-2024-011',
        origin: 'Long Beach, CA',
        destination: 'Phoenix, AZ',
        margin: 650.0,
        vessel: 'COSCO SHIPPING STAR',
        accounting_review_date: '2024-02-05T11:30:00Z',
        automated_billing_evaluated_paused_timestamp: null,
        automated_billing_evaluation_paused: 'No',
        automated_billing_evaluation_paused_reason: null,
        base_rate: 1700.0,
        bco: 'Desert Logistics',
        billing_status_billing_status: 'ready_to_bill',
        billing_status_billing_status_updated_at: '2024-02-04T10:00:00Z',
        billing_status_invoice_grouping: 'Weekly',
        billing_status_override_billing_status_note: null,
        billing_status_override_billing_status_reason_codes: null,
        billing_status_pending_accessorial_evaluation: 'Complete',
        billing_status_override_billing_status: null,
        cargo_description: 'Consumer Electronics',
        carrier_accessorial_total: 175.0,
        carrier_cost_total: 1900.0,
        carrier_fsc_total: 190.0,
        carrier_linehaul: 1400.0,
        carrier_other_accessorial_total: 135.0,
        carrier_total: 1900.0,
        container_number: 'CSLU5566778',
        created_at: '2024-02-01T10:00:00Z',
        created_by: 'iris.chen@cargomatic.com',
        date_created: '2024-02-01T11:30:00Z',
        destination_city: 'Phoenix',
        destination_name: 'Phoenix Warehouse District',
        destination_state: 'AZ',
        discussion: 'Arrived at destination - awaiting unload',
        hazmat_class: null,
        hazmat_description: null,
        hazmat_packaging: null,
        invoice_cliff_date: '2024-03-20T11:30:00Z',
        market: 'Southwest',
        missing_docs_report: 'None',
        mode: 'Truck',
        move_type: 'Import',
        order_carrier: 'Knight-Swift',
        order_received_date: '2024-01-31T11:30:00Z',
        order_status: 'arrived',
        order_timezone: 'America/Phoenix',
        order_type: 'Standard',
        order_updated: '2024-02-05T08:00:00Z',
        origin_city: 'Long Beach',
        origin_name: 'Port of Long Beach',
        origin_state: 'CA',
        billing_status_state_missing_for_ready_to_bill_unbilled_charges: 'None',
        billing_status_state_missing_for_ready_to_bill_required_docs: 'POD, BOL',
        billing_status_state_missing_for_ready_to_bill_missing_docs: 'None',
        billing_status_state_missing_for_ready_to_bill_required_reference_numbers: 'PO#',
        billing_status_state_missing_for_ready_to_bill_missing_reference_numbers: 'None',
        billing_status_state_missing_for_ready_to_bill_missing_accessorials: 'None',
        billing_status_state_missing_for_ready_to_bill_pending_accessorials: 'None',
        pending_carrier_accessorials: 'None',
        pending_shipper_accessorials: 'None',
        railroads: null,
        reference_numbers: [
            {
                name: 'master_bol',
                value: 'MB11234',
                optimized: 'MB11234',
                _id: '5bbd231b4c202300122ef013',
                hidden: false,
                editable: true,
            },
            {
                name: 'delivery_order',
                value: 'DO88990',
                optimized: 'DO88990',
                _id: '5bbd231b4c202300122ef014',
                hidden: false,
                editable: true,
            },
        ],
        service_type: 'Port-to-Door',
        shipment_id: 'SHP-2024-011-A',
        shipper: 'Desert Logistics Inc',
        shipper_accessorial_total: 225.0,
        shipper_account_support_agent: 'Wade Wilson',
        shipper_account_support_agent_tier2: 'Vanessa Carlysle',
        shipper_billing_rep: 'Weasel Jack',
        shipper_chassis_total: 50.0,
        shipper_cost_total: 2550.0,
        shipper_customer_success_manager: 'Colossus Steel',
        shipper_data_entry_agent: 'Negasonic Warhead',
        shipper_demurrage_total: 0.0,
        shipper_fsc_total: 255.0,
        shipper_linehaul: 1900.0,
        shipper_ops_group: 'West Coast Ops',
        shipper_ops_manager: 'Cable Nathan',
        shipper_other_accessorial_total: 120.0,
        shipper_sales_rep: 'Domino Luck',
        shipper_storage_total: 0.0,
        shipper_total: 2550.0,
        shorthaul_ops_customer_success: 'Dopinder Singh',
        shorthaul_ops_operations_manager: 'Russell Collins',
        standard_reference_numbers_booking_number: 'BK-2024-011',
        standard_reference_numbers_category: 'Import',
        standard_reference_numbers_delivery_order: 'DO-2024-011',
        standard_reference_numbers_final_destination: 'Phoenix, AZ',
        standard_reference_numbers_master_bol: 'MBOL-11234',
        standard_reference_numbers_mo_number: 'MO-2024-011',
        standard_reference_numbers_mode: 'Truck',
        standard_reference_numbers_po_number: 'PO-11234',
        standard_reference_numbers_work_order_number: 'WO-2024-011',
        steamship: 'COSCO',
        team_commercial_account_manager: 'Ajax Francis',
        team_commercial_sales_rep: 'Angel Dust',
        team_drayage_ops_customer_success: 'Blind Al',
        team_drayage_ops_data_entry: 'Bob Agent',
        total: 2550.0,
        total_invoiced: 0.0,
        train: null,
        unbilled_approved: 0.0,
        unbilled_charges: 0.0,
        unbilled_pending: 0.0,
        vendor_total: 1900.0,
        weight: 32000,
    },
];
const fetchOrders = async () => {
    // Simulate API call delay
    await new Promise((resolve) => setTimeout(resolve, 2500));
    // TODO: Replace with actual API call
    // return fetch('/api/orders').then(res => res.json());
    return stubOrderData;
};
export const useOrderData = () => {
    const query = useQuery({
        queryKey: ['orders'],
        queryFn: fetchOrders,
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
    });
    return query;
};
